"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAlert = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
var variants_1 = require("../../global/variants");
var shape_1 = require("../../global/shape");
exports.MuiAlert = {
    root: {
        alignItems: 'flex-start',
        padding: '16px 20px',
        '& .MuiAlertTitle-root': __assign(__assign({}, typography_1.typography.subtitle1), { marginTop: 0 }),
        borderRadius: 0,
        '&[class*="MuiAlert-standard"]': (_a = {
                '& a': __assign({ color: 'inherit' }, typography_1.typography.body2)
            },
            _a["&.".concat(variants_1.Variants.Alert.Inline)] = {
                justifyContent: 'flex-start',
                borderRadius: shape_1.shape.borderRadius,
                padding: '8px 12px',
                borderBottomWidth: 2,
                borderBottomStyle: 'solid',
                '& $icon': {
                    fontSize: 16,
                    padding: '4px 0 0',
                    marginLeft: 0,
                    marginRight: 12,
                    height: 20,
                },
                '& $message': {
                    padding: '3px 0',
                    color: 'inherit',
                    marginRight: 'auto',
                },
                '& $action': {
                    marginTop: -4,
                    marginBottom: -4,
                    marginRight: 0,
                },
            },
            _a),
    },
    icon: {
        width: '1em',
        fontSize: 24,
        marginRight: 18,
        display: 'inline',
    },
    action: {
        marginLeft: 'auto',
        color: palette_1.palette.common.black,
        '& svg': {
            fontSize: 14,
        },
    },
    message: {
        flexShrink: 20,
        color: palette_1.palette.common.black,
        maxWidth: 750,
    },
    standardError: (_b = {
            backgroundColor: palette_1.palette.error.contrastText
        },
        _b["&.".concat(variants_1.Variants.Alert.Inline)] = {
            color: palette_1.palette.error.dark,
            borderBottomColor: palette_1.palette.error.main,
        },
        _b),
    standardInfo: (_c = {
            backgroundColor: palette_1.palette.info.contrastText
        },
        _c["&.".concat(variants_1.Variants.Alert.Inline)] = {
            color: palette_1.palette.info.dark,
            borderBottomColor: palette_1.palette.info.main,
        },
        _c),
    standardSuccess: (_d = {
            backgroundColor: palette_1.palette.success.contrastText
        },
        _d["&.".concat(variants_1.Variants.Alert.Inline)] = {
            color: palette_1.palette.success.dark,
            borderBottomColor: palette_1.palette.success.main,
        },
        _d),
    standardWarning: (_e = {
            backgroundColor: palette_1.palette.warning.contrastText
        },
        _e["&.".concat(variants_1.Variants.Alert.Inline)] = {
            color: palette_1.palette.warning.dark,
            borderBottomColor: palette_1.palette.warning.main,
        },
        _e),
};
